import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import '../css/performances.css';
import { Helmet } from 'react-helmet';
import { fetchPageContent, contentLines, contentText } from '../utils/siteContent';

// The top note is sheet-editable free text, but we still want "opt out form"
// to link to the real opt-out page whenever that phrase appears in it. If
// she rewords the note and drops the phrase, this just renders plain text —
// no crash, it simply stops being a link until the phrase is there again.
function linkifyOptOutPhrase(text) {
    const phrase = 'opt out form';
    const idx = text.toLowerCase().indexOf(phrase);
    if (idx === -1) return text;

    return (
        <>
            {text.slice(0, idx)}
            <Link to="/opt-out">{text.slice(idx, idx + phrase.length)}</Link>
            {text.slice(idx + phrase.length)}
        </>
    );
}

export default function Performances() {
    const [content, setContent] = useState(null);

    useEffect(() => {
        fetchPageContent('Performances').then(setContent);
    }, []);

    return (
        <div className="performances-content">
            <Helmet>
                <title>In Motion Dance | Performances &#38; Recitals</title>
            </Helmet>
            <h1>Performances &#38; Recitals</h1>
            <p id="performances-topNote">
                {linkifyOptOutPhrase(contentText(content, 'top_note', 'All performances are optional. Since most dancers do perform, if you choose not to participate you are required to fill out an opt out form.'))}
            </p>

            <div className="performances-main">
                <h2>Performances</h2>
                <p>{contentText(content, 'winter_showcase', 'Winter Showcase: - (Younger classes) We hold an Open House holiday performance in December (date TBD) at Lake Mountain Middle School in Saratoga Springs (for time, see email). Those invited to perform at the Festival of Trees (info below) will not perform in this Winter Showcase. Costume & Participation fee required.')}</p>
                <p>{contentText(content, 'festival_of_trees', 'Festival of Trees - A fundraising event for Primary Children’s Hospital, held in the South Towne Expo Center in Sandy the first weekend in December 2026 (date TBD). Older classes will be invited to perform (see email for details). Those invited to perform in the Festival of Trees will not perform in the Winter Showcase. Requires costume fee ($65-$90), participation fee $55 per performer, and entrance fee for spectators.')}</p>
                {contentLines(content, 'end_of_year_recital', [
                    'End of Year Dance Recital - (June): Our End of the year dance recital will be June 20, 2026. Location - Lake Mountain Middle School.',
                    '(Ballet Call Time - 11:00am)',
                    '(Tumbling/Dance Call Time - 1:00pm)',
                    'To participate in the recital, there are two fees that need to be paid by March 15.',
                ]).map((line, i) => <p key={i}>{line}</p>)}
            </div>

            <div className="performances-recitals">
                <h2>Recital Fees</h2>

                <p className="performances-feeLabel"><strong>Costume fee:</strong></p>
                <p>{contentText(content, 'costume_fee', '$60-$90 fee per child for costumes (per class)')}</p>

                <p className="performances-feeLabel"><strong>Participation fee:</strong></p>
                {contentLines(content, 'participation_fee', [
                    '1 child = $55',
                    '2 children = $85',
                    "3+ children = $105 (only 1 fee, even if they're in all 3 recitals)",
                ]).map((line, i) => <p key={i}>{line}</p>)}

                <p>{contentText(content, 'participation_note', 'If your child is in more than one class you may choose which ones to participate in for recital. All fees must be paid in full by March 15. If you are participating, you may pay by check or charge to your debit/credit card. We need the recital/costume fees paid early since this helps the teachers to begin ordering costumes.')}</p>

                <p className="performances-feeLabel"><strong>Recital Tickets:</strong></p>
                <p>{contentText(content, 'recital_tickets', 'New this year! Fundraising or purchase options will be available. Details coming soon!')}</p>
            </div>

            <p id="performances-bottomNote">
                {contentText(content, 'bottom_note', 'Note: We are charged a very high fee to lease a school for the recitals and there are other significant costs associated with putting on a recital at a school. This is the reason for the recital fee.')}
            </p>
        </div>
    )
}
